/**
 * @changelog
 *
 * 2026-10-09 (0.1.0) (jhoward)
 *   - Add src\helpers\getPropertySiteLinks.ts, the Contact Us, Accessibility and Privacy Policy pages of the marketing
 *     site that belongs to a property. The navigation drawer's foot links all pointed at wendoverfun.com, so a Peppermill
 *     Reno or Western Village guest was sent to somebody else's site for the property they were signed in to.
 *     The URLs are the ones each property's own footer partial (resources/views/components/app-shell-footer-XX) links to.
 */

import type { PropertyCode } from '@/defs/property';

export interface PropertySiteLinks {
  contact: string;
  accessibility: string;
  privacy: string;
}

const propertySiteLinks: { [key in PropertyCode]: PropertySiteLinks } = {
  '2A': {
    contact: 'https://www.peppermillreno.com/about-us/contact-us-directions/',
    accessibility: 'https://www.peppermillreno.com/about-us/accessibility',
    privacy: 'https://www.peppermillreno.com/about-us/privacy-policy/',
  },
  '2B': {
    contact: 'https://www.westernvillagesparks.com/about/contact-us-directions/',
    accessibility: 'https://www.westernvillagesparks.com/about/accessibility/',
    privacy: 'https://www.westernvillagesparks.com/about/privacy-policy/',
  },
  '2C': {
    contact: 'https://wendoverfun.com/resort/contact-us',
    accessibility: 'https://wendoverfun.com/resort/accessibility',
    privacy: 'https://wendoverfun.com/resort/privacy-policy',
  },
};

/**
 * The links for a property. An unknown or not-yet-known property gets 2C's, as the contact form's fallback does, rather
 * than a drawer with nothing at its foot.
 */
export default function getPropertySiteLinks(propertyCode: PropertyCode | string | null | undefined): PropertySiteLinks {
  return propertySiteLinks[propertyCode as PropertyCode] ?? propertySiteLinks['2C'];
}
